import { takeLatest, put, call } from 'redux-saga/effects';
import { $authHost } from 'store/axios';
import {
  getBookingsList,
  getBookingsListSuccess,
  getBookingsListFailure,
  getBookingsDetail,
  getBookingsDetailSuccess,
  cancelService,
  cancelServiceSuccess,
  cancelServiceFailure,
  cancelBooking,
  cancelBookingSuccess,
  cancelBookingFailure,
  completeBooking,
  completeBookingSuccess,
  assignSpecialist,
  assignSpecialistSuccess,
} from './dashboardSlice';

function* getAllBookingsList(action) {
  const { payload } = action;
  try {
    const response = yield call($authHost.get, `/booking/business-bookings/${payload}`);
    if (response.data.code === 200) {
      yield put(getBookingsListSuccess(response.data.data.business_bookings));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      yield put(getBookingsListFailure(errorPreview));
    }
  }
}

// booking Details

function* getBookingDetailsSaga(action) {
  const { business_id, booking_id } = action.payload;
  try {
    const response = yield call(
      $authHost.get,
      `/booking/business-booking/${business_id}/${booking_id}`,
    );
    if (response.data.code === 200) {
      yield put(getBookingsDetailSuccess(response.data.data.business_bookings[0]));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      yield put(getBookingsListFailure(errorPreview));
    }
  }
}

// Cancel a service by business
function* cancelServiceSaga(action) {
  const { booking_id, service_id, reason, is_all_services_cancelled } = action.payload;
  try {
    const response = yield call($authHost.post, '/booking/cancel-service', {
      booking_id,
      service_id,
      reason,
      is_all_services_cancelled,
    });

    if (response.data.code === 200) {
      yield put(cancelServiceSuccess('Service canceled successfully.'));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      yield put(cancelServiceFailure(errorPreview));
    }
  }
}

// Cancel a booking by business
function* cancelBookingSaga(action) {
  const { booking_id } = action.payload;
  try {
    const response = yield call($authHost.put, `/booking/cancel-order-by-business/${booking_id}`);
    if (response.data.code === 200) {
      yield put(cancelBookingSuccess('Booking canceled successfully.'));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      yield put(cancelBookingFailure(errorPreview));
    }
  }
}

// Complete booking
function* completeBookingSaga(action) {
  const { booking_id } = action.payload;
  try {
    const response = yield call($authHost.put, `/booking/complete-order-by-business/${booking_id}`);
    if (response.data.code === 200) {
      yield put(completeBookingSuccess('Booking completed successfully.'));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      yield put(cancelBookingFailure(errorPreview));
    }
  }
}

// assign specialist to service
function* assignSepecialistToAService(action) {
  try {
    const response = yield call(
      $authHost.put,
      `/booking/assign-specialist-to-service`,
      action.payload,
    );
    if (response.data.code === 200) {
      yield put(assignSpecialistSuccess(response.data.message));
    }
  } catch (error) {
    if (error.response?.data) {
      const { code, message, description } = error.response.data;
      const errorPreview = { code, message, description };
      console.log(errorPreview.description);
    }
  }
}

export default function* dashboardSaga() {
  yield takeLatest(getBookingsList.type, getAllBookingsList);
  yield takeLatest(getBookingsDetail.type, getBookingDetailsSaga);
  yield takeLatest(cancelService.type, cancelServiceSaga);
  yield takeLatest(cancelBooking.type, cancelBookingSaga);
  yield takeLatest(completeBooking.type, completeBookingSaga);
  yield takeLatest(assignSpecialist.type, assignSepecialistToAService);
}
